<template>
  <modal closeMutation="SET_SHOP_RESERVATION_MODAL">
    <div v-if="schedule_event" class="modal_shop_schedule-payment-loader">
      <div class="modal-header">
        <div class="event_title">
          {{ schedule_event.name }}
        </div>
        <div class="event_place">
          {{ schedule_event.place }}
        </div>
      </div>

      <div class="modal_body">
        <div class="modal_body_top">
          <EventTrainer
              :trainer="schedule_event.trainer"
              :trainer-replacement="schedule_event.trainerReplacement"
          />
          <EventModalTimes
              :time="schedule_event.time"
              :date="schedule_event.date"
          />
          <EventIcons
              :schedule-event="schedule_event"
              :show-icon-description="true"
              v-if="(schedule_event.transfer && schedule_event.transfer.length === 0)"
          />
          <EventTransfer :transfer="schedule_event.transfer" v-else />
        </div>

        <!-- Загрузка. Записываем на занятие -->
        <div v-if="isBooking" class="modal_shop_payment-spinner">
          <img
              src="@/assets/img/loader.svg"
              alt="Загрузка"
              class="loader-icon"
          />
        </div>
        <p v-if="isBooking" class="modal_shop_payment-loader-text">
          Записываемся на занятие. Не закрывайте это окно
        </p>

        <!-- Успех -->
        <div v-if="isBooked" class="modal_shop_is_booked">
          <div class="form_success_bg">
            <img
                src="@/assets/img/success_reservation_background.svg"
                alt=""
            />
          </div>
          <div class="registration_form_is_booked_content">
            <div class="caption lg">
              {{ isWaiting ? 'Вы записаны в лист ожидания!' : 'Вы записаны!' }}
            </div>
            <button
                class="btn btn-to-lk"
                @click="goToHomeOrClose"
            >
              В личный кабинет
            </button>
          </div>
        </div>

        <!-- Ошибка -->
        <div
            v-if="bookingErrorMessage"
            class="modal_shop_reservation-error"
        >
          <div class="caption lg">{{ bookingErrorMessage }}</div>
        </div>
      </div>
    </div>

    <!-- Загрузка -->
    <div v-else class="modal_shop_schedule-payment-loader">
      <div class="modal_shop_payment-spinner">
        <img
            src="@/assets/img/loader.svg"
            alt="Загрузка"
            class="loader-icon"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/views/Modal";
import api from "@/api";
import EventModalTimes from "@/components/shop/EventModalTimes.vue";
import EventIcons from "@/components/shop/EventIcons.vue";
import EventTransfer from "@/components/shop/EventTransfer.vue";
import EventTrainer from "@/components/shop/EventTrainer.vue";
import {mapGetters} from "vuex";

export default {
  name: "ShopModalReservation",
  components: {
    EventTrainer,
    EventTransfer,
    EventIcons,
    EventModalTimes,
    Modal
  },
  props: {
    scheduleId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    ...mapGetters(['shopReservationBooked']),
  },
  data() {
    return {
      schedule_event: null,
      isBooking: true,
      isBooked: false,
      bookingErrorMessage: "",
      isWaiting: false,
    };
  },
  async mounted() {
      if (this.shopReservationBooked) {
          this.isBooking = false;
          this.isBooked = true;

          await this.loadScheduleEvent();
      } else {
          await this.loadScheduleEvent();
          await this.addReservation();
      }
  },
  methods: {
    calculateDuration(start, end) {
      const [h1, m1] = start.split(":").map(Number);
      const [h2, m2] = end.split(":").map(Number);
      return h2 * 60 + m2 - (h1 * 60 + m1);
    },
    async loadScheduleEvent() {
        try {
            const response = await api.schedule.getSchedule(this.scheduleId);
            const schedule = response.data;
            this.schedule_event = {
                ...schedule,
                time: {
                    start: schedule.time_start,
                    end: schedule.time_end,
                    duration: this.calculateDuration(schedule.time_start, schedule.time_end)
                },
                transfer: schedule.transfer_event
                    ? {
                        date: schedule.transfer_event.date,
                        time: {
                        start: schedule.transfer_event.time_start,
                          end: schedule.transfer_event.time_end
                        }
                    }
                    : [],
                trainerReplacement: schedule.trainer_replacement,
                avatar: schedule.trainer?.photo || ""
            };
        } catch (e) {
            console.error("Ошибка загрузки занятия:", e);
        }
    },
    async addReservation() {
      try {
        const result = (
            await api.schedule.postSchedule(this.scheduleId)
        ).data;
        if (result.status === "success" || result.status === "waiting") {
          await this.$store.dispatch("loadReservations");
          this.isBooking = false;
          this.isBooked = true;
          this.isWaiting = result.status === "waiting";
        }
      } catch (e) {
        this.isBooking = false;
        this.bookingErrorMessage =
            e.response?.data?.message || "Ошибка при записи на занятие";
        await this.$store.dispatch("loadReservations");
      }
    },
    goToHomeOrClose() {
      this.$store.commit('SET_SHOP_RESERVATION_MODAL', false);
      this.$store.commit('SET_SHOP_RESERVATION_BOOKED', false);

      if (this.$route.name !== 'Home') {
        this.$router.push({ name: 'Home' });
      }
    },
  }
};
</script>